import React, {useEffect, useState} from 'react';
import {RequestActivation} from "../../../../models/RequestActivation";
import {Button, Col, Divider, Form, message, Modal, Row, Select} from "antd";
import TextArea from "antd/es/input/TextArea";
import {useThemeLayoutConfig} from "../../../../config/ThemeDashboardLayoutConfig";
import {RequestActivationService} from "../../../../services/RequestActivationService";

interface CancelledStatusModalProps {
    isOpen: boolean;
    handleModalCancel: () => void;
    selectedRequestActivation: RequestActivation;
    submit: () => void;
}

function CancelledStatusModal({ isOpen, handleModalCancel, selectedRequestActivation, submit }: CancelledStatusModalProps) {
    const [messageApi, contextHolder] = message.useMessage();
    const themeConfig = useThemeLayoutConfig();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if(isOpen) {
            form.resetFields();
        }
    }, [isOpen])

    const onFinish = async (values: any) => {
        if(!loading) {
            const reason = values.reason;

            setLoading(true);

            const response = await RequestActivationService.updateStatusToCancelled(selectedRequestActivation.id, reason);

            setLoading(false);

            if(response.success) {
                messageApi.success(`Se canceló la solicitud de activación con el N° ${selectedRequestActivation.id}`);
                submit();
            }else {
                const error = response.data;
                messageApi.error(error.message as string || 'Hubo un error al intentar cancelar la solicitud de activación, por favor inténtalo nuevamente.', 3.5);
            }
        }
    }

    return (
        <>
            { contextHolder }

            <Modal
                title={<span>Solicitud N°:  <span style={{ color: themeConfig.token?.colorPrimary }} >{selectedRequestActivation.id}</span></span>}
                open={isOpen}
                onCancel={handleModalCancel}
                okText="Cancelar"
                maskClosable={false}
                destroyOnClose
                footer={null}
            >
                <Divider style={{ marginTop: '15px', marginBottom: '15px' }}/>

                <Form
                    form={form}
                    layout="vertical"
                    scrollToFirstError
                    onFinish={onFinish}
                >
                    <Row gutter={24}>
                        <Col xs={24}>
                            <Form.Item
                                name="reason"
                                label="Motivo"
                                rules={[{ required: true, message: 'Debes de ingresar el motivo de la cancelación.' }]}
                            >
                                <TextArea
                                    placeholder="Ingrese el motivo de la cancelación"
                                    rows={4}
                                    disabled={loading}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={24}>
                        <Col xs={24}>
                            <Button onClick={() => { form.submit(); }} loading={loading} type="primary" block>Cancelar solicitud</Button>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </>
    );
}

export default CancelledStatusModal;
